import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import RightRideLogo from "@public/images/logo-rightride.svg";
import RightRideLogoDark from "@public/images/logo-rightride-dark.svg";
import LocalImage from "@common/components/LocalImage";
import Link from "next/link";

type Props = {
  children: ReactNode[] | ReactNode;
};

const GoodbyeLayout = ({ children }: Props) => {
  const { t } = useTranslation("common");
  const currentYear = new Date().getFullYear();
  return (
    <div className="flex flex-col min-h-screen">
      <div className="fixed inset-x-0 top-0 z-50 h-20 bg-white">
        <div className="flex justify-between items-center mx-6 lg:mx-[120px] mt-4">
          <Link
            href="/"
            passHref
            role="link"
            tabIndex={0}
            className="[&>*]:align-middle focus:outline-none focus-visible:shadow-elevation-03"
          >
            <LocalImage
              width="173"
              height="39"
              className="hover:cursor-pointer"
              src={RightRideLogo}
              alt="RightRide Logo"
              priority
            />
          </Link>
        </div>
      </div>
      <div className="mt-20 flex-1">{children}</div>
      <div className="bg-primary-500 py-16">
        <LocalImage
          src={RightRideLogoDark}
          alt="RightRide Logo"
          className="mx-auto flex flex-shrink"
        />
        <div className="flex flex-row justify-center gap-x-10 text-center text-white mt-5 caption-4">
          <p>{`© ${currentYear} ${t("rightride")}`}</p>
          <Link href="/privacy-policy" className="underline">
            {t("privacy_policy")}
          </Link>
          <Link href="/terms-conditions" className="underline">
            {t("terms_and_conditions")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GoodbyeLayout;
